import { RootState } from 'store/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { CalendarState } from 'component/page/detail/store/calendar';
import { CalendarActivityResult } from 'gql/autogen/CalendarActivityResult';
import { BookingRequirement } from 'gql/autogen/BookingRequirement';
import { findBookingRequirementById } from 'gql/service/graph/activityService';

const EmptyObject = {};

const mapActivityCalendar = (calendarState?: CalendarState): CalendarActivityResult => {
    const result = (calendarState && calendarState.calendarResponse && calendarState.calendarResponse.result) || (EmptyObject as CalendarActivityResult);
    return result || EmptyObject;
};

export const mapActivityBookingRequirementsFromCalendar = (calendarState?: CalendarState, requirementId = 0): BookingRequirement => {
    const result = mapActivityCalendar(calendarState);
    return findBookingRequirementById(result?.bookingRequirements, requirementId);
};

export const selectCalendarState = (state: RootState) => state.detailCalendar;
export const selectAdditionalCalendarLoading = (state: RootState) => state.detailCalendar.isAdditionalCalendarLoading;
export const selectFetchedMonths = (state: RootState) => state.detailCalendar.fetchedMonths;
export const selectResultFromCalendarState = createSelector(selectCalendarState, (state) => (state && state.calendarResponse?.result) || ({} as CalendarActivityResult));
export const selectSchedulesFromCalendarState = createSelector(selectResultFromCalendarState, (state) => (state && state.calendar?.schedules) || []);
export const selectOfferLevelCalendarsFromCalendarState = createSelector(selectCalendarState, (state) => state.offerLevelCalendars);
export const selectIsSchedulesEmpty = createSelector(selectSchedulesFromCalendarState, (schedules) => schedules.length === 0);
export const selectIsSoldOut = createSelector(selectSchedulesFromCalendarState, (schedules) => schedules.filter((schedule) => schedule.isAvailable).length === 0);
export const selectIsSchedulesAllUnavailable = createSelector(selectSchedulesFromCalendarState, (schedules) => schedules.every((schedule) => schedule.isAvailable === false));
export const selectIsCalendarLoading = createSelector(selectCalendarState, (state) => state.isLoading);
